import { styled } from "styled-components";

export const SearchSectionWrapper = styled.div`
  background-color: ${(props) => props.theme.colours.primary.white};
`;
